import { render, staticRenderFns } from "./TradeStatistics.vue?vue&type=template&id=3364a999&"
import script from "./TradeStatistics.vue?vue&type=script&lang=js&"
export * from "./TradeStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports